// generated by genversion
export var version = '5.1.11';
//# sourceMappingURL=version.js.map